import { LogOut, MessageSquare, Briefcase, FileEdit, Package, Image, Quote } from 'lucide-react';

function NavButton({ testId, active, icon: Icon, label, count, onClick }) {
  return (
    <button
      data-testid={testId}
      onClick={onClick}
      className="w-full flex items-center justify-between px-4 py-3 rounded-xl text-sm font-semibold transition-all duration-200"
      style={{
        backgroundColor: active ? 'rgba(255,255,255,0.15)' : 'transparent',
        color: active ? '#fff' : 'rgba(255,255,255,0.6)',
      }}
    >
      <span className="flex items-center gap-3">
        <Icon size={16} />
        {label}
      </span>
      {count !== undefined && (
        <span
          className="text-xs font-bold px-2 py-0.5 rounded-full"
          style={{ backgroundColor: active ? '#D97706' : 'rgba(255,255,255,0.2)', color: '#fff' }}
        >
          {count}
        </span>
      )}
    </button>
  );
}

export default function AdminSidebar({ tab, onTabChange, inquiryCount, dealerCount, user, onLogout }) {
  return (
    <aside className="w-64 flex flex-col flex-shrink-0 sticky top-0 h-screen" style={{ backgroundColor: '#0A3F22' }}>
      <div className="p-6 border-b" style={{ borderColor: 'rgba(255,255,255,0.1)' }}>
        <div className="flex items-center gap-3">
          <div
            className="w-10 h-10 rounded-xl flex items-center justify-center font-black text-sm"
            style={{ backgroundColor: '#D97706', color: '#fff' }}
          >
            ARV
          </div>
          <div>
            <div className="font-heading font-bold text-white text-sm">ARV Machinery</div>
            <div className="text-xs" style={{ color: 'rgba(255,255,255,0.5)' }}>Admin Portal</div>
          </div>
        </div>
      </div>

      <nav className="flex-1 p-4 space-y-1">
        <NavButton
          testId="nav-inquiries"
          active={tab === 'inquiries'}
          icon={MessageSquare}
          label="Product Inquiries"
          count={inquiryCount}
          onClick={() => onTabChange('inquiries')}
        />
        <NavButton
          testId="nav-dealer-apps"
          active={tab === 'dealers'}
          icon={Briefcase}
          label="Dealer Applications"
          count={dealerCount}
          onClick={() => onTabChange('dealers')}
        />
        <NavButton
          testId="nav-content"
          active={tab === 'content'}
          icon={FileEdit}
          label="Site Content"
          onClick={() => onTabChange('content')}
        />
        <NavButton
          testId="nav-products"
          active={tab === 'products'}
          icon={Package}
          label="Products"
          onClick={() => onTabChange('products')}
        />
        <NavButton
          testId="nav-gallery"
          active={tab === 'gallery'}
          icon={Image}
          label="Gallery"
          onClick={() => onTabChange('gallery')}
        />
        <NavButton
          testId="nav-testimonials"
          active={tab === 'testimonials'}
          icon={Quote}
          label="Testimonials"
          onClick={() => onTabChange('testimonials')}
        />
      </nav>

      <div className="p-4 border-t" style={{ borderColor: 'rgba(255,255,255,0.1)' }}>
        <div className="flex items-center gap-3 px-2 mb-3">
          <div
            className="w-8 h-8 rounded-full flex items-center justify-center text-xs font-bold"
            style={{ backgroundColor: 'rgba(255,255,255,0.2)', color: '#fff' }}
          >
            {user?.email?.[0]?.toUpperCase() || 'A'}
          </div>
          <div className="flex-1 min-w-0">
            <div className="text-xs font-semibold text-white truncate">{user?.name || 'Admin'}</div>
            <div className="text-xs truncate" style={{ color: 'rgba(255,255,255,0.5)' }}>{user?.email}</div>
          </div>
        </div>
        <button
          data-testid="admin-logout-btn"
          onClick={onLogout}
          className="w-full flex items-center gap-2 px-4 py-2.5 rounded-xl text-sm font-semibold transition-all hover:opacity-80"
          style={{ backgroundColor: 'rgba(255,255,255,0.1)', color: 'rgba(255,255,255,0.8)' }}
        >
          <LogOut size={15} />
          Sign Out
        </button>
      </div>
    </aside>
  );
}
